// Happy pastel palette — Macaron shop / Easter egg vibe. Each color has
// its own soft background and a slightly deeper border so cards still
// read as distinct in a dense grid. Dark-mode variants intentionally dim
// the tint without muting it to grey.
export const NOTE_COLORS = [
  { key: "default", name: "Paper",      swatch: "#FFFFFF",
    cls: "bg-white dark:bg-stone-900 border-stone-200 dark:border-stone-800" },
  { key: "bubblegum", name: "Bubblegum", swatch: "#FFCFE1",
    cls: "bg-pink-100 dark:bg-pink-950/50 border-pink-300 dark:border-pink-800/50" },
  { key: "rose",      name: "Rose",      swatch: "#FFDADB",
    cls: "bg-rose-100 dark:bg-rose-950/50 border-rose-300 dark:border-rose-800/50" },
  { key: "coral",     name: "Coral",     swatch: "#FFC9B0",
    cls: "bg-orange-100 dark:bg-orange-950/50 border-orange-300 dark:border-orange-800/50" },
  { key: "mango",     name: "Mango",     swatch: "#FFD9A3",
    cls: "bg-amber-100 dark:bg-amber-950/50 border-amber-300 dark:border-amber-800/50" },
  { key: "butter",    name: "Butter",    swatch: "#FFF5B8",
    cls: "bg-yellow-100 dark:bg-yellow-950/50 border-yellow-300 dark:border-yellow-800/50" },
  { key: "lime",      name: "Lime",      swatch: "#DEF5B0",
    cls: "bg-lime-100 dark:bg-lime-950/50 border-lime-300 dark:border-lime-800/50" },
  { key: "pistachio", name: "Pistachio", swatch: "#CFEFCF",
    cls: "bg-emerald-100 dark:bg-emerald-950/50 border-emerald-300 dark:border-emerald-800/50" },
  { key: "mint",      name: "Mint",      swatch: "#C7F0E2",
    cls: "bg-teal-100 dark:bg-teal-950/50 border-teal-300 dark:border-teal-800/50" },
  { key: "sky",       name: "Sky",       swatch: "#C9EBFF",
    cls: "bg-sky-100 dark:bg-sky-950/50 border-sky-300 dark:border-sky-800/50" },
  { key: "periwinkle",name: "Periwinkle",swatch: "#D4D9FF",
    cls: "bg-indigo-100 dark:bg-indigo-950/50 border-indigo-300 dark:border-indigo-800/50" },
  { key: "lilac",     name: "Lilac",     swatch: "#E4D1FF",
    cls: "bg-violet-100 dark:bg-violet-950/50 border-violet-300 dark:border-violet-800/50" },
  { key: "cotton",    name: "Cotton",    swatch: "#F0D5FF",
    cls: "bg-fuchsia-100 dark:bg-fuchsia-950/50 border-fuchsia-300 dark:border-fuchsia-800/50" },
];

export const colorClass = (key) =>
  (NOTE_COLORS.find((c) => c.key === key) || NOTE_COLORS[0]).cls;

export const colorSwatch = (key) =>
  (NOTE_COLORS.find((c) => c.key === key) || NOTE_COLORS[0]).swatch;
